import {
  FETCH_CARTS_DATA_REQUEST,
  FETCH_CARTS_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  isFetching: true,
  page: 1,
  size: 20,
  sortBy: "",
  totalCount: 0,
  carts: []
};

export const cartsReducer = createReducer(initialState, {
  [FETCH_CARTS_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  },
  [FETCH_CARTS_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  }
});

export default cartsReducer;
